import React from 'react';
import LoadingSpinner from './LoadingSpinner';

export const LoadingOverlaySmall = ({ open }) => {
  if (!open) return null;

  return (
    <div className="absolute inset-0 bg-white/50 flex items-center justify-center z-10 rounded-xl">
      <LoadingSpinner size="lg" />
    </div>
  );
};

export const LoadingOverlay = ({ open }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <LoadingSpinner size="xl" />
    </div>
  );
};

export default LoadingOverlay;
